<app-header title="Manage Campaigns"></app-header>
<ng-container [ngSwitch]="mode">
  <ng-container *ngSwitchCase="'list'">
    <div class="container pt-5 mt-5">
      <div class="d-flex justify-content-between mb-3">
        <div class="campaign__title">{{id ? campaign.value.name: 'Hindu Temple Puja'}} Campaign</div>
        <div class="campaign__action-list d-flex align-items-center">
          <button class="btn btn--paybee btn--outline-transparent mr-2"(click)="onCancel()">Cancel</button>
          <button [ngClass]="imageService.loadingClasses()" class="btn btn--paybee btn--success" (click)="onSave()">Save Campaign</button>
        </div>
      </div>
    </div>

    <mdb-tabs #tabs class="mdb-tabs" (activeTabChange)="tabsService.onTabChange($event)">
      <mdb-tab title="Campaign Configuration">
        <div class="background__color--white py-4">
          <div class="container">
            <div class="row mb-4">
              <div class="col-4 d-flex flex-row align-items-center">
                <div class="card__title mr-1">Basic Details</div>
              </div>
            </div>
            <app-campaign-general-info
              [panel]="accordionService.map.general"
              [formGroupCampaign]="campaign"
              (afterCollapse)="accordionService.onAfterCollapse('general')"
              (afterExpand)="accordionService.onAfterExpand('general')"
              [formGroupCampaign]="campaign"
              [settings]="settings"
            ></app-campaign-general-info>
            
            <mdb-accordion [multiple]="true">
              <mdb-accordion-item [collapsed]="!accordionService.map.coverFee.expanded" (itemShown)="accordionService.onAfterExpand('coverFee')" (itemHidden)="accordionService.onAfterCollapse('coverFee')">
                <ng-template mdbAccordionItemHeader>Cover Fee Settings</ng-template>
                <ng-template mdbAccordionItemBody>
                  <app-campaign-cover-fee-settings [formGroupCampaign]="campaign"></app-campaign-cover-fee-settings>
                </ng-template>
              </mdb-accordion-item>

              <mdb-accordion-item [collapsed]="!accordionService.map.eMail.expanded" (itemShown)="accordionService.onAfterExpand('eMail')" (itemHidden)="accordionService.onAfterCollapse('eMail')">
                <ng-template mdbAccordionItemHeader>E-Mail Settings</ng-template>
                <ng-template mdbAccordionItemBody>
                  <app-campaign-email-settings [formGroupCampaign]="campaign"></app-campaign-email-settings>
                </ng-template>
              </mdb-accordion-item>

              <mdb-accordion-item [collapsed]="!accordionService.map.settings.expanded" (itemShown)="accordionService.onAfterExpand('settings')" (itemHidden)="accordionService.onAfterCollapse('settings')">
                <ng-template mdbAccordionItemHeader>Hindu Temple Puja Settings</ng-template>
                <ng-template mdbAccordionItemBody>
                  <app-campaign-hindu-temple-puja-settings [formGroupCampaignTypeData]="campaignTypeData"></app-campaign-hindu-temple-puja-settings>
                </ng-template>
              </mdb-accordion-item>
            </mdb-accordion>
          </div>
        </div>
      </mdb-tab>
      <mdb-tab title="Hindu Temple Puja Options">
        <div class="background__color--white py-4">
          <div class="container">
            <div class="card__header mb-3">
              <div class="row w-100">
                <div class="col-12 d-flex justify-content-between">
                  <div class="card__left-side card__title d-flex">
                    <span class="d-flex align-items-center mr-2">Options</span>
                    <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="changeMode('option-form')">+ Add</button>
                  </div>
                  <div class="card__right-side d-flex justify-content-end search">
                    <div class="search__icon-wrapper">
                      <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <title>Icons/search</title>
                          <defs>
                              <rect id="path-1" x="0" y="0" width="726" height="404" rx="8"></rect>
                              <filter id="filter-3">
                                  <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                              </filter>
                          </defs>
                          <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <g id="Large" transform="translate(-858.000000, -165.000000)">
                                  <rect fill="#f1f1f1" x="0" y="0" width="1024" height="882"></rect>
                                  <g id="Card" transform="translate(274.000000, 150.000000)">
                                      <mask id="mask-2" fill="white">
                                          <use xlink:href="#path-1"></use>
                                      </mask>
                                      <g id="Rectangle"></g>
                                  </g>
                                  <g id="Icons/search" transform="translate(858.000000, 165.000000)">
                                      <g filter="url(#filter-3)" id="Color">
                                          <g>
                                              <path d="M8.05514748,-6.92779167e-14 C3.61630998,-6.92779167e-14 0,3.61627943 0,8.05514748 C0,12.4939989 3.61630443,16.1103033 8.05514748,16.1103033 C9.97490799,16.1103033 11.7382908,15.4316646 13.1243348,14.3048316 L18.5754498,19.755941 C18.9008413,20.0813298 19.4305328,20.0813576 19.7559438,19.755941 C20.0813521,19.4305245 20.0813521,18.9095246 19.7559438,18.5841359 L14.3048316,13.1330265 C15.4339396,11.7462769 16.110295,9.97705522 16.110295,8.05514748 C16.110295,3.61627943 12.4939878,-6.92779167e-14 8.05514748,-6.92779167e-14 Z M8.05514748,1.66658281 C11.5932936,1.66658281 14.4437122,4.51697637 14.4437122,8.05514748 C14.4437122,11.5932769 11.593288,14.4437205 8.05514748,14.4437205 C4.51700692,14.4437205 1.66658281,11.5932769 1.66658281,8.05514748 C1.66658281,4.51697637 4.51700137,1.66658281 8.05514748,1.66658281 Z" id="search" fill="#000000" fill-rule="nonzero"></path>
                                          </g>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </svg>
                    </div>
                    <input [formControl]="search" class="form-control--search" placeholder="Search" />
                    <div class="search__icon-wrapper--cross px-1"><span class="cursor-pointer" *ngIf="search.value.length > 0" (click)="resetSearch()">X</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card__content">
              <app-campaign-option-list
                [index]="scrollToIndex"
                (onEdit)="onEditOption($event)"
              ></app-campaign-option-list>
            </div>
            <div *ngIf="campaignOptionListService.activeList.length > 1" class="drag-and-drop d-flex align-items-center justify-content-center mt-3">Drag and drop options to reorder or use Move.</div>
          </div>
          <app-campaign-deleted-option-list></app-campaign-deleted-option-list>
        </div>
      </mdb-tab>
      <mdb-tab title="Sponsors" *ngIf="id">
        <div class="background__color--white py-4">
          <div class="container d-flex flex-column align-items-center" *ngIf="sponsorGroupFactory.state === 'first-step'">
            <div class="sponsor-group__description mt-5">To start adding sponsors, first Create a Sponsor Group or select an existing group.</div>
            <div class="sponsor-group__description mb-4">Once created you can reuse this for any campaign.</div>
            <div class="d-flex align-items-center justify-content-center">
              <div style="width: 250px;" class="mr-2" *ngIf="sponsorGroupListService.list.length > 0">
                <mdb-form-control class="form-fill">
                  <mdb-select [formControl]="sponsorGroupControl" class="mdb-select">
                    <mdb-option *ngFor="let sponsorGroup of sponsorGroupListService.list" [value]="sponsorGroup.id">{{
                      sponsorGroup.name
                    }}</mdb-option>
                  </mdb-select>
                  <label mdbLabel class="form-label form-label--paybee">Select Sponsor Group</label>
                </mdb-form-control>
              </div>
              <button class="btn btn--mb25 btn--paybee btn-sm modal-confirm-button mr-2" (click)="sponsorGroupFactory.onCreateSponsorGroup()">+ Create New</button>
            </div>
            <div class="card__content">
            </div>
          </div>
          <div class="container" *ngIf="sponsorGroupFactory.state === 'second-step'">
            <div class="card__header mb-3">
              <div class="row w-100">
                <div class="col-12 d-flex justify-content-between">
                  <div class="card__title d-flex align-items-center">
                    <span class="d-flex align-items-center mr-2">{{sponsorGroupFactory.name}}</span>
                    <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="changeMode('sponsor-form')">+ Add</button>
                  </div>
                  <div *ngIf="!sponsorGroupListService.selected?.id" class="d-flex align-items-center">
                    <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="sponsorGroupFactory.onSaveSponsorGroup()" [disabled]="sponsorGroupEmpty">Save Sponsor Group</button>
                  </div>
                  <div *ngIf="sponsorGroupListService.selected?.id" class="d-flex align-items-center">
                    <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="sponsorGroupFactory.onUpdateSponsorGroup()" [disabled]="sponsorGroupEmpty">Update</button>
                    <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="sponsorGroupFactory.onDeleteSponsorGroup()">Remove</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card__content">
              <app-campaign-sponsor-list [index]="scrollToIndex"
                [formGroupCampaign]="campaign"
                (onDelete)="onSave($event)"
                (onEditSponsor)="editSponsor($event)"
              ></app-campaign-sponsor-list>
            </div>
            <div *ngIf="sponsorsCollection.found.length > 1" class="drag-and-drop d-flex align-items-center justify-content-center mt-3">Drag and drop sponsors to reorder or use Move.</div>
          </div>
        </div>
      </mdb-tab>
      <mdb-tab title="Sponsors" *ngIf="!id">
        <div class="background__color--white py-4">
          <div class="container d-flex flex-column align-items-center">
            <div class="sponsor-group__description mt-5">Come back to this screen to add sponsors to this campaign after it is created. Edit the campaign to add sponsors.</div>
          </div>
        </div>
      </mdb-tab>
    </mdb-tabs>


  </ng-container>
  <ng-container *ngSwitchCase="'option-form'">
    <div class="container pt-5 mt-5">
      <div class="campaign-option__back d-flex align-items-center mb-1">
        <div class="campaign-option__arrow--back mr-2">
          <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Path</title>
            <defs>
                <filter id="filter-1">
                    <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                </filter>
            </defs>
            <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.327584403">
                <g id="New-Option-Header" transform="translate(-25.000000, -31.000000)">
                    <g id="Header" transform="translate(25.000000, 29.000000)">
                        <g id="Group">
                            <g filter="url(#filter-1)" id="Title-2">
                                <g>
                                    <path d="M14,7.9082345 C14,7.40965047 13.5958178,7.00546826 13.0972338,7.00546826 L3.19614499,7.00546826 L6.86588976,3.5839842 C7.11510392,3.36724892 7.22607028,3.03172226 7.15522243,2.70913513 C7.08437457,2.38654799 6.84302279,2.12839883 6.52592404,2.03603942 C6.20882529,1.94368 5.86660186,2.03185477 5.63361384,2.26594548 L0.286980768,7.24695823 C0.103934415,7.41770376 0,7.65678625 0,7.90710605 C0,8.15742585 0.103934415,8.39650834 0.286980768,8.56725386 L5.63361384,13.5505235 C5.99820341,13.8908071 6.56961602,13.8711032 6.90989962,13.5065137 C7.25018322,13.1419241 7.23047934,12.5705115 6.86588976,12.2302279 L3.19614499,8.81100075 L13.0972338,8.81100075 C13.5958178,8.81100075 14,8.40681853 14,7.9082345 Z" id="Path" fill="#B3B3B3" fill-rule="nonzero"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
          </svg>
        </div>
        <div class="campaign-option__campaign-name">{{id ? campaign.value.name: 'Hindu Temple Puja'}}</div>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <div class="campaign__title">{{selectedOption ? selectedOption.value.name: 'New Option' }}</div>
          <div *ngIf="selectedOption" class="row option-nav">
            <div class="option-nav__container d-flex">
              <div class="d-flex align-items-center cursor-pointer px-2" (click)="goToPrevOption()">
                <svg width="8px" height="16px" viewBox="0 0 8 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>Path</title>
                    <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Edit-Option" transform="translate(-278.000000, -72.000000)" fill="#000000" fill-rule="nonzero">
                            <g id="Option-Selector" transform="translate(278.000000, 70.000000)">
                                <path d="M7.99807202,9.7644437 C7.98420815,9.5705644 7.90577459,9.38692287 7.77529816,9.24284896 L1.51614213,2.28822922 C1.30845184,2.0571933 0.993275146,1.95451988 0.689351938,2.01889021 C0.38542873,2.08326055 0.138939531,2.30489369 0.0427468445,2.60029143 C-0.0534458421,2.89568917 0.0152742712,3.2199664 0.223017524,3.45095471 L5.96057707,9.82421866 L0.223017524,16.197467 C0.0152742712,16.4284553 -0.0534458421,16.7527325 0.0427468446,17.0481302 C0.138939531,17.343528 0.385428731,17.5651611 0.689351938,17.6295315 C0.993275146,17.6939018 1.30845184,17.5912284 1.51614213,17.3601925 L7.77529816,10.4055727 C7.93335339,10.2308726 8.01374539,9.99950951 7.99807202,9.7644437 L7.99807202,9.7644437 Z" id="Path" transform="translate(4.000000, 9.824211) scale(-1, 1) translate(-4.000000, -9.824211) "></path>
                            </g>
                        </g>
                    </g>
                </svg>
              </div>
              <div class="option-nav__position">{{selectedOptionIndex + 1}} of {{campaignOptionListService.activeList.length}}</div>
              <div class="d-flex align-items-center cursor-pointer px-2" (click)="goToNextOption()">
                <svg width="8px" height="16px" viewBox="0 0 8 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>Path</title>
                    <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Edit-Option" transform="translate(-996.000000, -72.000000)" fill="#000000" fill-rule="nonzero">
                            <g id="Option-Selector" transform="translate(278.000000, 70.000000)">
                                <path d="M725.998072,9.7644437 C725.984208,9.5705644 725.905775,9.38692287 725.775298,9.24284896 L719.516142,2.28822922 C719.308452,2.0571933 718.993275,1.95451988 718.689352,2.01889021 C718.385429,2.08326055 718.13894,2.30489369 718.042747,2.60029143 C717.946554,2.89568917 718.015274,3.2199664 718.223018,3.45095471 L723.960577,9.82421866 L718.223018,16.197467 C718.015274,16.4284553 717.946554,16.7527325 718.042747,17.0481302 C718.13894,17.343528 718.385429,17.5651611 718.689352,17.6295315 C718.993275,17.6939018 719.308452,17.5912284 719.516142,17.3601925 L725.775298,10.4055727 C725.933353,10.2308726 726.013745,9.99950951 725.998072,9.7644437 L725.998072,9.7644437 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="campaign__action-list d-flex align-items-center">
          <button class="btn btn--paybee btn--outline-transparent mr-2"(click)="optionComponent.onCancel()">Cancel</button>
          <button [ngClass]="imageService.loadingClasses()" class="btn btn--paybee btn--black" (click)="optionComponent.saveCampaignOption()">Save Option</button>
        </div>
      </div>
    </div>
    <div class="background__color--white py-4">
      <div class="container">
        <div class="card__content">
          <app-campaign-hindu-temple-puja-option
            [formGroupCampaignTypeData]="campaignTypeData"
            [selected]="selectedOption"
            (onChangeData)="onChangeCampaignOption($event)"
          ></app-campaign-hindu-temple-puja-option>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'sponsor-form'">
    <div class="container py-3 pt-5 mt-5">
      <div class="campaign-sponsor__back d-flex align-items-center mb-1">
        <div class="campaign-sponsor__arrow--back mr-2">
          <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Path</title>
            <defs>
                <filter id="filter-1">
                    <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                </filter>
            </defs>
            <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.327584403">
                <g id="New-Sponsor-Header" transform="translate(-25.000000, -31.000000)">
                    <g id="Header" transform="translate(25.000000, 29.000000)">
                        <g id="Group">
                            <g filter="url(#filter-1)" id="Title-2">
                                <g>
                                    <path d="M14,7.9082345 C14,7.40965047 13.5958178,7.00546826 13.0972338,7.00546826 L3.19614499,7.00546826 L6.86588976,3.5839842 C7.11510392,3.36724892 7.22607028,3.03172226 7.15522243,2.70913513 C7.08437457,2.38654799 6.84302279,2.12839883 6.52592404,2.03603942 C6.20882529,1.94368 5.86660186,2.03185477 5.63361384,2.26594548 L0.286980768,7.24695823 C0.103934415,7.41770376 0,7.65678625 0,7.90710605 C0,8.15742585 0.103934415,8.39650834 0.286980768,8.56725386 L5.63361384,13.5505235 C5.99820341,13.8908071 6.56961602,13.8711032 6.90989962,13.5065137 C7.25018322,13.1419241 7.23047934,12.5705115 6.86588976,12.2302279 L3.19614499,8.81100075 L13.0972338,8.81100075 C13.5958178,8.81100075 14,8.40681853 14,7.9082345 Z" id="Path" fill="#B3B3B3" fill-rule="nonzero"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
          </svg>
        </div>
        <div class="campaign-sponsor__campaign-name">{{id ? campaign.value.name: 'Ticketing'}}</div>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <div class="campaign__title">{{selectedSponsor ? selectedSponsor.value.name: 'New Sponsor' }}</div>
          <div *ngIf="selectedSponsor" class="row sponsor-nav">
            <div class="sponsor-nav__container d-flex">
              <div class="d-flex align-items-center cursor-pointer px-2">
                <svg width="8px" height="16px" viewBox="0 0 8 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>Path</title>
                    <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Edit-Sponsor" transform="translate(-278.000000, -72.000000)" fill="#000000" fill-rule="nonzero">
                            <g id="Sponsor-Selector" transform="translate(278.000000, 70.000000)">
                                <path d="M7.99807202,9.7644437 C7.98420815,9.5705644 7.90577459,9.38692287 7.77529816,9.24284896 L1.51614213,2.28822922 C1.30845184,2.0571933 0.993275146,1.95451988 0.689351938,2.01889021 C0.38542873,2.08326055 0.138939531,2.30489369 0.0427468445,2.60029143 C-0.0534458421,2.89568917 0.0152742712,3.2199664 0.223017524,3.45095471 L5.96057707,9.82421866 L0.223017524,16.197467 C0.0152742712,16.4284553 -0.0534458421,16.7527325 0.0427468446,17.0481302 C0.138939531,17.343528 0.385428731,17.5651611 0.689351938,17.6295315 C0.993275146,17.6939018 1.30845184,17.5912284 1.51614213,17.3601925 L7.77529816,10.4055727 C7.93335339,10.2308726 8.01374539,9.99950951 7.99807202,9.7644437 L7.99807202,9.7644437 Z" id="Path" transform="translate(4.000000, 9.824211) scale(-1, 1) translate(-4.000000, -9.824211) "></path>
                            </g>
                        </g>
                    </g>
                </svg>
              </div>
              <div class="sponsor-nav__position">{{selectedSponsorIndex + 1}} of {{sponsorsCollection.list.length}}</div>
              <div class="d-flex align-items-center cursor-pointer px-2">
                <svg width="8px" height="16px" viewBox="0 0 8 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>Path</title>
                    <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Edit-Sponsor" transform="translate(-996.000000, -72.000000)" fill="#000000" fill-rule="nonzero">
                            <g id="Sponsor-Selector" transform="translate(278.000000, 70.000000)">
                                <path d="M725.998072,9.7644437 C725.984208,9.5705644 725.905775,9.38692287 725.775298,9.24284896 L719.516142,2.28822922 C719.308452,2.0571933 718.993275,1.95451988 718.689352,2.01889021 C718.385429,2.08326055 718.13894,2.30489369 718.042747,2.60029143 C717.946554,2.89568917 718.015274,3.2199664 718.223018,3.45095471 L723.960577,9.82421866 L718.223018,16.197467 C718.015274,16.4284553 717.946554,16.7527325 718.042747,17.0481302 C718.13894,17.343528 718.385429,17.5651611 718.689352,17.6295315 C718.993275,17.6939018 719.308452,17.5912284 719.516142,17.3601925 L725.775298,10.4055727 C725.933353,10.2308726 726.013745,9.99950951 725.998072,9.7644437 L725.998072,9.7644437 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="campaign__action-list d-flex align-items-center">
          <button class="btn btn--paybee btn--outline-transparent mr-2"(click)="sponsorComponent.onCancel()">Cancel</button>
          <button [ngClass]="imageService.loadingClasses()" class="btn btn--paybee btn--black" (click)="sponsorComponent.saveCampaignSponsor()">Save Sponsor</button>
        </div>
      </div>
    </div>
    <div class="background__color--white py-4">
      <div class="container">
        <div class="card__content">
          <app-campaign-sponsor
            [formGroupCampaign]="campaign"
            [selected]="selectedSponsor"
            [selectedIndex]="selectedSponsorIndex"
            (onChangeData)="onChangeCampaignSponsor($event)"
          ></app-campaign-sponsor>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
